const initialState = {
    productList: null,
    error: null,
    loading: false,
    productFromTable: []
};
  
const temporalPricesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPLOAD_TEMPORAL_FILE_SUCCESS':
      return {
        ...state,
        productList: action.payload,
        loading: false
      };
    case 'UPLOAD_TEMPORAL_FILE_START':
      return {
        ...state,
        loading: true,
      };
    case 'UPLOAD_TEMPORAL_FILE_FAILURE':
      return {
        ...state,
        error: action.payload,
        loading: false
      };
    case 'DOWNLOAD_TEMPORAL_PRICES_FILE':
      return {
        ...state,
        productFromTable: action.payload,
      };
    // Otros casos para otras acciones
    default:
      return state;
  }
};
  
  export default temporalPricesReducer;